import { useEffect } from 'preact/hooks';
import { changes } from '../../subs';
import { Change } from '../../types';

export function useOnTime(time: number, fn: Function) {
  useEffect(() => {
    const listener = ({ event, partial }: Change) => {
      if (event !== 'AdDurationChange') return;

      if (
        isNaN(partial.duration!) ||
        isNaN(partial.remainingTime!) ||
        partial.duration! - partial.remainingTime! < time
      ) {
        return;
      }

      fn();

      changes.unsubscribe(listener);
    };
    changes.subscribe(listener);

    return () => changes.unsubscribe(listener);
  }, []);
}
